// extracted by css-extract-rspack-plugin
export default {"resultTableContainer":"BulkReleaseHoldsModal_resultTableContainer__XNe4V"};